import { defineStore } from 'pinia'
import actions from './actions'
import mutations from './mutations'
import getters from './getters'
import { getLocalSelections } from '@ms/components/betslip/core/save.js'

export const useWapBetslipStore = defineStore('wapBetslip', {
  state: () => ({
    selectionList: getLocalSelections(),
    fastStake: 0 // 快速投注的stake
  }),
  getters,
  actions: {
    ...actions,
    ...mutations
  }
})
